import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export default function AIErrorMessage({ message, onDismiss }) {
  if (!message) return null;
  return (
    <Alert
      severity="error"
      variant="outlined"
      sx={{
        mx: 2,
        mb: 1,
        borderRadius: 2,
        alignItems: "center",
        "& .MuiAlert-message": { fontSize: 13 },
      }}
      action={
        onDismiss ? (
          <IconButton aria-label="Dismiss error" size="small" onClick={onDismiss} color="inherit">
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        ) : null
      }
    >
      {message}
    </Alert>
  );
}

AIErrorMessage.propTypes = {
  message: PropTypes.string,
  onDismiss: PropTypes.func,
};
